import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useAuth } from "@/context/AuthContext";
import { SearchRecordWeek } from "@/components/search/SearchRecordWeek";
import { SearchRecordAll } from "@/components/search/SearchRecordAll";
import { SearchEnginePanel } from "@/components/search/SearchEnginePanel";

export default function SearchRecordPage() {
  const { has } = useAuth();
  return (
    <div data-testid="search-record-page" className="max-w-5xl">
      <h1 className="font-display text-2xl font-bold tracking-tight">Search record</h1>
      <p className="text-sm text-slate-500 mb-5">What was typed in the search boxes, and every scan that found nothing — with the role of whoever searched, never their name. Each one is removed after 90 days.</p>
      <Tabs defaultValue="week">
        <TabsList className="mb-4 h-auto min-h-11 max-w-full flex-wrap justify-start">
          <TabsTrigger data-testid="sr-tab-week" value="week" className="h-9 px-4">This week's "found nothing"</TabsTrigger>
          <TabsTrigger data-testid="sr-tab-all" value="all" className="h-9 px-4">Every search</TabsTrigger>
          {has("switch_search_engine") && <TabsTrigger data-testid="sr-tab-engine" value="engine" className="h-9 px-4">Search engine</TabsTrigger>}
        </TabsList>
        <TabsContent value="week"><SearchRecordWeek /></TabsContent>
        <TabsContent value="all"><SearchRecordAll /></TabsContent>
        {has("switch_search_engine") && <TabsContent value="engine"><SearchEnginePanel /></TabsContent>}
      </Tabs>
    </div>
  );
}
